import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {BrowserRouter as Router} from "react-router-dom";
import {
    AppBar,
    Collapse,
    colors, CssBaseline, Divider,
    Drawer, IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText, Menu, MenuItem, Toolbar
} from "@material-ui/core";
import Routes from "./Routes";
import {AppContext} from "./libs/contextLib";
import {Auth} from "aws-amplify";
import {useHistory} from "react-router-dom";
import {AccountCircle, ExpandLess, ExpandMore} from "@material-ui/icons";
import LaptopChromebookIcon from '@material-ui/icons/LaptopChromebook';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {UVT_MATERIAS} from "./Source/Materias";
import {UVT_LEFT_NAV_LIST} from "./Source/LeftNavList";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerContainer: {
        overflow: 'auto',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    title: {
        flexGrow: 1,
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
}));

export const USER_MAJOR = {
    "aramis001@gmail.com": "admin",
    "testing_uvt_001@mailinator.com": "psico",
    "testing_uvt_002@mailinator.com": "petrolera",
    "testing_uvt_003@mailinator.com": "industrial",
    "testing_uvt_004@mailinator.com": "admin",
}

function App(props) {
    const classes = useStyles();
    const history = useHistory();
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [isAuthenticated, userHasAuthenticated] = useState(false);
    const [userEmail, setUserEmail] = useState("aramis001@gmail.com");
    const [anchorEl, setAnchorEl] = useState(null);
    const [open, setOpen] = useState(false);
    const openProfile = Boolean(anchorEl);

    const handleClick = () => {
        setOpen(!open);
    };

    useEffect(() => {
        onLoad();
    }, []);


    async function handleLogout() {
        try {
            const response = await Auth.signOut();
            console.log(response, 'response app');
            userHasAuthenticated(false);
            history.push("/login");
        } catch (e) {
            console.log(e);
        }
    }

    async function onLoad() {
        try {
            await Auth.currentSession();
            const response = await Auth.currentUserInfo();
            setUserEmail(response.attributes.email);
            userHasAuthenticated(true);
        } catch (e) {
            console.log("No user");
        } finally {
            setIsAuthenticating(false);
        }
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <Router>
            <div className={classes.root}>
                <CssBaseline/>
                <LPAppBar
                    classes={classes}
                    isAuthenticated={isAuthenticated}
                    handleLogout={handleLogout}
                    handleClose={handleClose}
                    anchorEl={anchorEl}
                    openProfile={openProfile}
                    history={history}
                    userHasAuthenticated={userHasAuthenticated}
                />
                <LPDrawer
                    classes={classes}
                    isAuthenticated={isAuthenticated}
                    handleClick={handleClick}
                    open={open}
                    history={history}
                    handleLogout={handleLogout}
                    major={USER_MAJOR[userEmail]}
                />
                <main className={classes.content}>
                    <Toolbar/>
                    <AppContext.Provider value={{isAuthenticated, userHasAuthenticated, userEmail}}>
                        <Routes/>
                    </AppContext.Provider>
                </main>
            </div>
            );
        </Router>
    );
}

export default App;

function LPAppBar({classes, isAuthenticated, handleMenu, anchorEl, openProfile, handleClose, userHasAuthenticated}) {
    const history = useHistory();

    async function handleLogout() {
        try {
            const response = await Auth.signOut();
            console.log(response, 'response app');
            userHasAuthenticated(false);
            history.push("/login");
        } catch (e) {
            console.log(e);
        }
    }

    return (
        <AppBar position="fixed" className={classes.appBar}>
            <Toolbar>
                <Typography className={classes.title} variant="h6" noWrap>
                    {/*<SchoolIcon /> */}
                    UVT En Línea
                </Typography>
                {isAuthenticated
                    ? <div>
                        <IconButton
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <AccountCircle/>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={openProfile}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleClose}>Mi Perfil</MenuItem>
                            <MenuItem onClick={handleClose}>Otra opción</MenuItem>
                        </Menu>
                        <Button color="inherit" onClick={handleLogout}>Cerrar Sesión</Button>
                    </div>
                    : <Button color="inherit" onClick={() => history.push("/login")}>Entrar</Button>
                }
            </Toolbar>
        </AppBar>
    );
}

function LPDrawer({classes, isAuthenticated, handleClick, open, handleLogout, major}) {
    const history = useHistory();

    function redirectTo(url) {
        history.push(url);
    }

    function capitalize(str) {
        const lower = str.toLowerCase();
        return str.charAt(0).toUpperCase() + lower.slice(1);
    }

    return (
        <Drawer
            className={classes.drawer}
            variant="permanent"
            classes={{
                paper: classes.drawerPaper,
            }}
        >
            <Toolbar/>
            <div className={classes.drawerContainer}>
                <List className={classes.leftBar}>
                    <List>
                        {UVT_LEFT_NAV_LIST.map((o, index) => (
                            <ListItem button key={`nav-${index}`}
                                      disabled={!isAuthenticated}
                                      onClick={() => redirectTo(o.redirectTo)}
                                      value="kjhkjhkjh"
                            >
                                <ListItemIcon>
                                    {o.icon}
                                </ListItemIcon>
                                <ListItemText primary={o.title}/>
                            </ListItem>
                        ))}
                    </List>
                    <Divider/>
                    <ListItem button
                              key="lm-materias-expand-button"
                              onClick={handleClick}
                              className={classes.materias}
                              disabled={!isAuthenticated}>
                        <ListItemIcon>
                            <LaptopChromebookIcon/>
                        </ListItemIcon>
                        <ListItemText primary="Materias"/>
                        {open ? <ExpandLess/> : <ExpandMore/>}
                    </ListItem>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            {Object.keys(UVT_MATERIAS[major]).map(o => UVT_MATERIAS[major][o].materias).flat().map(o => {
                                return (
                                    <ListItem button
                                              key={`lm-materias-${o.topicId}`}
                                              className={classes.nested}
                                              disabled={o.disabled}
                                              onClick={() => history.push(`/materias/${major}/${o.topicId}`)}
                                    >
                                        <ListItemIcon>
                                            <LibraryBooksIcon/>
                                        </ListItemIcon>
                                        <ListItemText primary={capitalize(o.name)}
                                                      classes={{secondary: colors.purple}}/>
                                        <ListItemSecondaryAction>
                                            {o.enabled
                                                ? <CheckCircleIcon className={classes.checked}/>
                                                : <></>}
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Collapse>
                </List>
            </div>
        </Drawer>
    );
}
